import split from 'lodash/split';
import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { setContextApiCall } from '../../contactUs/actions/action-article';
import { isOmniChannelAPITriggeredInSession } from '../../lib/globalHelper';
import { isSetContextEnabled } from '../../lib/omnichannelHelper';

const ARTICLE_URL = '/smarthelp/article-content';

function requestArticle() {
  return { type: types.REQUEST_MACHINE_ARTICLE };
}

function receiveArticle(responseData) {
  return {
    type: types.RECEIVE_MACHINE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveArticleError() {
  return { type: types.RECEIVE_MACHINE_ARTICLE_ERROR };
}

export default function fetchMachineArticle({ faqId, locale }) {
  return (dispatch, getState) => {
    dispatch(requestArticle());
    const faq = split(faqId, ',')[0];
    let articleURL = `${ARTICLE_URL}?article_id=${faq}`;

    const topicDetails = _get(getState(), 'selectResult.topicTreeSelectResult', {});

    // Checking the session storage for omni channel API triggered value from session
    const setContextTriggered = isOmniChannelAPITriggeredInSession();

    if (locale) {
      articleURL = Page.setURLQuery(articleURL, 'locale', locale);
    }

    return axios.get(articleURL)
      .then((response) => {
        if (response.data && response.data.articleContent) {
          dispatch(receiveArticle(response.data.articleContent));

          const articleIntents = isSetContextEnabled(topicDetails, response.data);

          // Set context Validations and API call
          if (!setContextTriggered && Array.isArray(articleIntents) && articleIntents.length > 0) {
            dispatch(setContextApiCall(articleIntents, faq, false));
          }
        }
      })
      .catch(() => {
        dispatch(receiveArticleError());
      });
  };
}
